import { mui } from '@local/finsera-core/src/libs';

const FinFilterTrigger = () => {
  return (
    <mui.dataGrid.FilterPanelTrigger
      render={
        <mui.dataGrid.ToolbarButton
          render={
            <mui.core.Button type="button" size="small" sx={{ border: '0px!important', padding: '0 4px!important' }}>
              Filters
            </mui.core.Button>
          }
        />
      }
    />
  );
};

export default FinFilterTrigger;
